import { CtaTile, MainLayoutContainer, Text } from '@lune-fe/lune-ui-lib'
import Stack from '@mui/material/Stack'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import useTitle from 'hooks/useTitle'
import shareYourImpact from 'images/share-your-impact.png'

const GoToMarket: FC = () => {
    useTitle('Go-to-market')
    const navigate = useNavigate()

    return (
        <MainLayoutContainer headerComponent={<Text variant={'h4'}>Go-to-market</Text>}>
            <Stack spacing={{ xs: 4 }}>
                <CtaTile
                    key={`go-to-market-share-your-impact`}
                    title={'Share your impact'}
                    image={shareYourImpact}
                    subTitle={'Make your sustainability efforts visible'}
                    onClick={() => {
                        navigate(`/share-your-impact`)
                    }}
                />
            </Stack>
        </MainLayoutContainer>
    )
}

export default GoToMarket
